"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheMuseCollective() {
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -10% 0px"
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    rootMargin: "0px 0px -10% 0px"
  });
  return <section data-section-id="223725" id="about-us" className="bg-background text-foreground w-full min-h-screen flex flex-col lg:flex-row overflow-hidden">
      {}
      <div className="lg:w-[60%] relative min-h-[60vh] lg:min-h-screen overflow-hidden bg-muted">
        <div ref={imgRef} className={`absolute inset-0 w-full h-full transition-transform duration-[2000ms] ease-out ${isImgVisible ? "scale-100" : "scale-110"}`}>
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678509/img/corporate_leaders_ai_innovation.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678509/img/corporate_leaders_ai_innovation.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678509/img/corporate_leaders_ai_innovation.png-wvc-sizes" alt="Two energetic corporate leaders with AI and innovation background" className="w-full h-full object-cover rounded-lg" loading="lazy" decoding="async" />
          {}
          <div className="absolute inset-0 bg-primary/5 mix-blend-multiply"></div>
        </div>
      </div>

      {}
      <div className="lg:w-[40%] flex flex-col justify-center px-6 py-20 md:px-16 lg:px-20 xl:px-24 bg-background z-10 relative">
        <div ref={contentRef} className={`transition-all duration-1000 delay-300 ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <span className="text-accent font-mono text-xs md:text-sm tracking-widest mb-10 block uppercase font-semibold">
            20+ Years &mdash; Fortune 500 Expertise
          </span>

          {}
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-[1.1] tracking-tighter mb-12 text-primary">Corporate Power.<br />Start-Up Agility.</h2>

          {}
          <div className="space-y-8 text-muted-foreground font-default text-base md:text-lg leading-relaxed">
            <p>JC Sourcing Partners is powered by a network of Senior Strategic Sourcing experts with 20+ years of Fortune 500 experience. We bridge the gap between global procurement standards and the agile needs of emerging companies.</p>
            <p>We help medium &amp; large companies and growing startups to reduce costs, improve supplier relationships, and drive innovation through smarter sourcing strategies and AI-enhanced insights that increase profit margins.</p>
            <div className="grid grid-cols-2 gap-4 pt-4">
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm font-medium text-foreground">
                  <span className="text-accent"></span> Flexible Plastics
                </li>
                <li className="flex items-center gap-2 text-sm font-medium text-foreground">
                  <span className="text-accent"></span> Rigid Plastics
                </li>
                <li className="flex items-center gap-2 text-sm font-medium text-foreground">
                  <span className="text-accent"></span> Glass & Metals
                </li>
              </ul>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm font-medium text-foreground">
                  <span className="text-accent"></span> Corrugated Board
                </li>
                <li className="flex items-center gap-2 text-sm font-medium text-foreground">
                  <span className="text-accent"></span> Solid Board
                </li>
                <li className="flex items-center gap-2 text-sm font-medium text-foreground">
                  <span className="text-accent"></span> Logistics Opt.
                </li>
              </ul>
            </div>
          </div>
          
          {}
          <div className="absolute -bottom-10 -right-10 opacity-10 pointer-events-none select-none">
            <span className="font-default text-[120px] font-bold text-primary leading-none">20+</span>
          </div>
        </div>
      </div>
    </section>;
}